/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ expiry_date: NonNullable<unknown> }} Subscribed_Card_ErrorInputs */

const en_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Renewal Payment Issue
Subscription End Date: ${i?.expiry_date}`)
};

const ar_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مشكلة دفع التجديد
تاريخ انتهاء الاشتراك: ${i?.expiry_date}`)
};

const de_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erneuerung Zahlungsausgabe
Enddatum der Zeichnung: ${i?.expiry_date}`)
};

const es_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Emisión de pago de renovación
Fecha de finalización de la suscripción: ${i?.expiry_date}`)
};

const fr_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur de paiement du renouvellement
Date de fin de l'abonnement: ${i?.expiry_date}`)
};

const it_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Problema di pagamento del rinnovo 
Data di fine dell'abbonamento: ${i?.expiry_date}`)
};

const ja_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`更新時のお支払いエラー
サブスクリプション終了日：${i?.expiry_date}`)
};

const ko_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`갱신 결제 이슈
구독 종료일: ${i?.expiry_date}`)
};

const pt_br_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Problema no pagamento da renovação
Data de término da assinatura: ${i?.expiry_date}`)
};

const ru_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Проблема с оплатой продления
Дата окончания подписки: ${i?.expiry_date}`)
};

const th_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ปัญหาการชำระเงินการต่ออายุ
วันสิ้นสุดการสมัครสมาชิก: ${i?.expiry_date}`)
};

const tr_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yenileme Sırasında Ödeme Sorunu
Abonelik Bitiş Tarihi: ${i?.expiry_date}`)
};

const zh_cn_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`续费付款异常
Plus 会员到期日：${i?.expiry_date}`)
};

const zh_tw_subscribed_card_error = /** @type {(inputs: Subscribed_Card_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`續訂付款異常
訂閱到期日：${i?.expiry_date}`)
};

/**
* | output |
* | --- |
* | "Renewal Payment Issue Subscription End Date: {expiry_date}" |
*
* @param {Subscribed_Card_ErrorInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscribed_card_error = /** @type {((inputs: Subscribed_Card_ErrorInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscribed_Card_ErrorInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscribed_card_error(inputs)
	if (locale === "ar") return ar_subscribed_card_error(inputs)
	if (locale === "de") return de_subscribed_card_error(inputs)
	if (locale === "es") return es_subscribed_card_error(inputs)
	if (locale === "fr") return fr_subscribed_card_error(inputs)
	if (locale === "it") return it_subscribed_card_error(inputs)
	if (locale === "ja") return ja_subscribed_card_error(inputs)
	if (locale === "ko") return ko_subscribed_card_error(inputs)
	if (locale === "pt_br") return pt_br_subscribed_card_error(inputs)
	if (locale === "ru") return ru_subscribed_card_error(inputs)
	if (locale === "th") return th_subscribed_card_error(inputs)
	if (locale === "tr") return tr_subscribed_card_error(inputs)
	if (locale === "zh_cn") return zh_cn_subscribed_card_error(inputs)
	return zh_tw_subscribed_card_error(inputs)
});